import { connectUserAccount } from 'src/features/account/duck/connectors'
import SelectUser from './SelectUser'

export default connectUserAccount(SelectUser)
